import * as React from "react";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Container,
  FlexRow,
  H1,
  H2,
  IconX,
  PageHeader,
  RichText,
  Stack,
} from "atoms";
import { OpenCall } from "../types";

type ContentShowing = null | "details" | "how-to";

type OpenCallVoteWrapperProps = {
  openCall: OpenCall;
  titlePrefix: React.ReactNode;
  howToLabel: React.ReactNode;
  howToContent: React.ReactNode;
  howToTitle: React.ReactNode;
  showingOnOpen?: ContentShowing;
  children: React.ReactNode;
};

function OpenCallVoteWrapper({
  openCall,
  titlePrefix,
  howToLabel,
  howToContent,
  howToTitle,
  children,
  showingOnOpen = null,
}: OpenCallVoteWrapperProps) {
  const [showing, setShowing] = React.useState<ContentShowing>(showingOnOpen);
  const closeContent = () => setShowing(null);

  const createBtnProps = (
    content: ContentShowing,
  ): Partial<React.ComponentProps<typeof Button>> => ({
    onClick: () => setShowing(showing === content ? null : content),
    disabled: showing === content,
  });

  return (
    <main>
      <PageHeader>
        <H1>
          {titlePrefix}
          <br />
          {openCall.title}
        </H1>
      </PageHeader>

      <Container width="lg">
        <ButtonRow justifyContent="flex-end" gap="10px">
          <Button {...createBtnProps("details")} size="xs">
            Open Call Details
          </Button>
          <Button {...createBtnProps("how-to")} size="xs">
            {howToLabel}
          </Button>
        </ButtonRow>

        {showing === "details" && (
          <Box>
            <FlexRow
              alignItems="flex-start"
              justifyContent="space-between"
              itemsFlex="1"
              flexWrap="nowrap"
            >
              <H2 size="h3">Details</H2>
              <Button
                variant="blank"
                size="xxs"
                onClick={closeContent}
                style={{ flex: "0 0 auto" }}
              >
                <IconX />
              </Button>
            </FlexRow>
            <RichText value={openCall.description} />
          </Box>
        )}

        {showing === "how-to" && (
          <Box>
            <Stack gap="md">
              <FlexRow
                alignItems="flex-start"
                justifyContent="space-between"
                flexWrap="nowrap"
              >
                <H2 size="h3">{howToTitle}</H2>

                <Button
                  variant="blank"
                  size="xxs"
                  onClick={closeContent}
                  style={{ flex: "0 0 auto" }}
                >
                  <IconX />
                </Button>
              </FlexRow>

              {howToContent}
            </Stack>
          </Box>
        )}
      </Container>

      {children}
    </main>
  );
}

const ButtonRow = styled(FlexRow)({
  marginTop: "1rem",
  marginBottom: "1rem",
});
export { OpenCallVoteWrapper };
